/**
 * Golf Practice Schedule Reducers
 */
import {
    PRACTICESCHEDULE_ACTION,
    STUDENT_PRACTICESCHEDULE,
    ALL_PSSHOTS,
    SELECT_SHOTTYPE,
    ADD_PRACTICESCHEDULE_SUCCESS,
 } from 'Actions/types';
 
 
 const INIT_STATE = {
    studentpracticelist:[],
    loading: false,
    allshotlist:[],
 };
 
 export default (state = INIT_STATE, action) => {
     switch (action.type) {
         
        case PRACTICESCHEDULE_ACTION:
            return { ...state, loading: true };
 
        case STUDENT_PRACTICESCHEDULE:
            return { ...state, loading: false, studentpracticelist: action.payload };  

        case ALL_PSSHOTS:
            return { ...state, loading: false, allshotlist: action.payload };      
        
        case SELECT_SHOTTYPE:
            return { ...state, loading: false };

        case ADD_PRACTICESCHEDULE_SUCCESS:
            return { ...state, loading: false };    
        
         default: return { ...state };
     }
 }